module.exports = __webpack_public_path__ + "img/wibo-05.a30c9e90.jpg";